<div class="page gray-font-color font-family bodyBackground birth-location">
  @if (errorMessage) {
    <mat-error class="error padding-left-md">
      {{ errorMessage }}
    </mat-error>
  }
  <div class="header-navigation-back">
    <mat-icon (click)="navigateBack()" data-test="back-arrow-icon" data-testid="back-arrow-icon">arrow_back</mat-icon>
    @if (!isStripeSessionActive) {
      <span class="title">Conviction</span>
    }
    @if (isStripeSessionActive) {
      <span class="title">Order PCC</span>
    }
  </div>
  @if (!isStripeSessionActive) {
    <form [formGroup]="criminalConvictionForm">
      <!-- <div class="header-navigation-back">
      <mat-icon (click)="navigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
      <span class="title">Conviction</span>
    </div> -->
    <div class="conviction-container" data-test="conviction-container" data-testid="conviction-container">
      <div class="info">
        <p>All declared convictions will be included in your report</p>
      </div>
      @if (!showConvictionToAdd && !showAddedConvictions) {
        <div>
          <div class="has-conviction">
            <mat-label class="conviction-label">Do you have any convictions to add?</mat-label>
            <mat-form-field class="full-width">
              <mat-select (selectionChange)="onChange($event.value)" required data-test="has-conviction" data-testid="has-conviction">
                <mat-option value="yes" data-test="yes-conviction" data-testid="yes-conviction">Yes</mat-option>
                <mat-option value="no" data-test="no-conviction" data-testid="no-conviction">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div [ngClass]="!noConvictions ? 'declare-info' : 'no-conviction-info'" data-test="conviction-info" data-testid="conviction-info">
            <h3>
              Do not declare the following
            </h3>
            <ul>
              <li>
                A conviction for which you have a Record Suspension (formerly pardon) in accordance with the Criminal
                Records Act.
              </li>
              <li>A conviction where you were a ‘young person’ under the Youth Criminal Justice Act.</li>
              <li>An absolute or Conditional Discharge, pursuant to section 730 of the Criminal Code.</li>
              <li>An offense for which were not convicted.</li>
              <li>Any provincial or municipal offense.</li>
              <li>Any charges dealt with outside of Canada.</li>
              <li>
                Note that a Certified Criminal Record can only be issued based on the submission of fingerprints to the
                RCMP National Repository on Criminal Records.
              </li>
            </ul>
          </div>
          @if (noConvictions) {
            <div class="btn-container">
              @if (!isManagedUserDriver) {
                <button class="btn-finish full-width" (click)="showCompleteJobConfirmation()" data-test="finish-button" data-testid="finish-button">
                  PROCEED TO PAY
                </button>
              }
              @if (isManagedUserDriver) {
                <button class="btn-finish full-width" (click)="showCompleteJobConfirmation()" data-test="finish-button" data-testid="finish-button">
                  PROCEED
                </button>
              }
            </div>
          }
        </div>
      }
      @if (showConvictionToAdd && !showAddedConvictions) {
        <div class="add-conviction" data-test="add-conviction" data-testid="add-conviction-form">
          <mat-label class="conviction-label">conviction offense*</mat-label>
          <mat-form-field class="full-width">
            <mat-select formControlName="convictionOffense" data-test="nature-of-offense" data-testid="nature-of-offense">
              @for (offense of criminalOffense; track offense) {
                <mat-option [value]="offense" data-test="offense-type" [attr.data-testid]="'offense-' + (offense | lowercase)"
                  >{{ offense }}
                </mat-option>
              }
            </mat-select>
            @if (
              criminalConvictionForm.get('convictionOffense').touched &&
              criminalConvictionForm.get('convictionOffense').invalid
              ) {
              <mat-error
                >
                {{ requiredMessage }}</mat-error
                >
              }
            </mat-form-field>
            <mat-label class="conviction-label">Date of Sentence*</mat-label>
            <mat-form-field class="full-width">
              <input
                matInput
                readonly
                [matDatepicker]="dateOfSentence"
                formControlName="dateOfSentence"
                [max]="maxDate"
                (click)="dateOfSentence.open()"
                data-test="data-of-sentence"
                data-testid="date-of-sentence"
                />
              <mat-datepicker-toggle matSuffix [for]="dateOfSentence" data-test="from-date-form-field" data-testid="sentence-date-toggle">
                <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #dateOfSentence touchUi="true"> </mat-datepicker>
              @if (
                criminalConvictionForm.get('dateOfSentence').touched &&
                criminalConvictionForm.get('dateOfSentence').invalid
                ) {
                <mat-error
                  >
                  {{ requiredMessage }}
                </mat-error>
              }
            </mat-form-field>
            <mat-label class="conviction-label">Court Location*</mat-label>
            <mat-form-field class="full-width">
              <input
                matInput
                formControlName="courtLocation"
                #courtLocation
                (focus)="getLocation()"
                data-test="court-location-field"
                data-testid="court-location-field"
                />
              @if (
                criminalConvictionForm.get('courtLocation').touched && criminalConvictionForm.get('courtLocation').invalid
                ) {
                <mat-error
                  >
                  {{ requiredMessage }}</mat-error
                  >
                }
              </mat-form-field>
              <mat-label class="conviction-label">Description*</mat-label>
              <mat-form-field class="full-width">
                <input matInput formControlName="description" data-test="description-field" data-testid="description-field" />
                @if (
                  criminalConvictionForm.get('description').touched && criminalConvictionForm.get('description').invalid
                  ) {
                  <mat-error
                    >
                    {{ requiredMessage }}</mat-error
                    >
                  }
                </mat-form-field>
                <div class="btn-container btn-flex-view">
                  <button class="btn-save-conviction full-width" (click)="addConviction(false)" data-test="save-conviction" data-testid="save-conviction">
                    SAVE CONVICTION
                  </button>
                  <button class="btn-cancel  full-width" (click)="cancelConviction()" data-test="cancel-conviction" data-testid="cancel-conviction">
                    CANCEL
                  </button>
                </div>
              </div>
            }
            @if (showAddedConvictions) {
              <div class="added-convictions" data-test="added-conviction" data-testid="added-conviction">
                @for (data of convictionsData; track data; let idx = $index) {
                  <div
                    class="conviction-record"
                    data-test="conviction-record"
                    [attr.data-testid]="'conviction-record-' + (data.offense | lowercase)"
                    >
                    <div class="conviction-info">
                      <p class="conviction-date">{{ data.sentenceDate | date: 'dd MMM yyyy' }}</p>
                      <span class="update-icon">
                        <mat-icon
                          svgIcon="edit-black"
                          class="icons-list"
                          (click)="onUpdateConviction(data, idx)"
                          data-test="edit-conviction-record"
                          [attr.data-testid]="'edit-conviction-' + (data.offense | lowercase)"
                        ></mat-icon>
                        <mat-icon
                          class="icons-list"
                          svgIcon="delete-sweep-outlined"
                          (click)="onDeleteConviction(idx)"
                          data-test="delete-conviction-record"
                          [attr.data-testid]="'delete-conviction-' + (data.offense | lowercase)"
                        ></mat-icon>
                      </span>
                      <p class="conviction-nature" data-test="conviction-offense" [attr.data-testid]="'conviction-offense-' + (data.offense | lowercase)">
                        {{ data.offense }}
                      </p>
                    </div>
                  </div>
                }
                <div class="btn-container">
                  @if (convictionsData?.length < 3) {
                    <button
                      class="btn-save full-width"
                      (click)="addConviction(true)"
                      [disabled]="loading"
                      data-test="add-conviction"
                      data-testid="add-conviction"
                      >
                      ADD CONVICTION
                    </button>
                  }
                  @if (convictionsData?.length && !isManagedUserDriver) {
                    <button
                      class="btn-finish full-width"
                      (click)="showCompleteJobConfirmation()"
                      [disabled]="loading"
                      data-test="save-all-conviction"
                      data-testid="save-all-conviction"
                      >
                      PROCEED TO PAY
                    </button>
                  }
                  @if (convictionsData?.length && isManagedUserDriver) {
                    <button
                      class="btn-finish full-width"
                      (click)="showCompleteJobConfirmation()"
                      [disabled]="loading"
                      data-test="save-all-conviction"
                      data-testid="save-all-conviction"
                      >
                      PROCEED
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        </form>
      }
    </div>
    <!-- <div id="checkout" *ngIf="isStripeSessionActive"></div> -->
    <div #checkoutContainer class="checkout-container"></div>